import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import {useParams, Navigate, useNavigate} from 'react-router-dom';
import {useAuth} from '../../../contexts/UserContext';
import styled from 'styled-components';
import config from '../../../config';
import {PageMainTitle} from '../../atoms/CommonParts';

const Page = styled.div`
`;

const PageFeatureTitle = styled.div`
  border-bottom: 1px solid #000000;
  position: relative;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;

  @media ${config.layout.wide} {
  }

  h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
  }
`;

const RegisteredDeviceBlock = styled.div`
  border-radius: 2px;
  position: relative;
  padding: 30px 20px;
  margin-bottom: 40px;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #000000;
  @media ${config.layout.wide} {
    width: 350px;
  }
`;

const RegisteredDeviceDataArea = styled.div`
  height: 170px;
  display: flex;
  justify-content: space-between;
`;

const RegisteredDeviceImageArea = styled.div`
  width: 40.6%;
  height: 100%;
  flex: 0 2 auto;
  background-color: #F8F8F8;
  background-size: 130px auto;
  background-position: center;
  background-repeat: no-repeat;
  @media ${config.layout.wide} {
    width: 34.8%;
  }
`;

const RegisteredDeviceInfoArea = styled.div`
  width: 59.4%;
  height: 100%;
  flex: 1 1 auto;
  padding: 0 0 0 20px;

  @media ${config.layout.wide} {
    width: 65.2%;
  }
`;

const RegisteredDeviceInfo = styled.div`
  h4 {
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    display: block;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    margin-top: 4px;
    margin-bottom: 13px;
    white-space: nowrap;
  }
`;

const ApplyButton = styled.a`
/*
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 13px;
    height: 13px;
    top: 17px;
    right: 15px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 13 13'%3E%3Cg id='グループ_1028' data-name='グループ 1028' transform='translate(-866 -693)'%3E%3Crect id='長方形_728' data-name='長方形 728' width='1' height='10' transform='translate(869 693)' fill='%23fff'/%3E%3Crect id='長方形_736' data-name='長方形 736' width='1' height='10' transform='translate(866 696)' fill='%23fff'/%3E%3Crect id='長方形_734' data-name='長方形 734' width='1' height='10' transform='translate(878 693)' fill='%23fff'/%3E%3Crect id='長方形_729' data-name='長方形 729' width='1' height='10' transform='translate(879 702) rotate(90)' fill='%23fff'/%3E%3Crect id='長方形_737' data-name='長方形 737' width='1' height='10' transform='translate(876 705) rotate(90)' fill='%23fff'/%3E%3Crect id='長方形_735' data-name='長方形 735' width='1' height='10' transform='translate(879 693) rotate(90)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A");
  }
 */
`;

const LabelAboveButton = styled.div`
  font-size: 12px;
  font-weight: bold;
  margin-top: 40px;
  text-align: center;
  padding-bottom: 40px;
  @media ${config.layout.wide} {
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const LabelBelowButton = styled.div`
  font-size: 12px;
  font-weight: bold;
  margin-top: 40px;
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid #000000;
`;

export default function KUVOCareApplyPage() {
  const app = useApp();
  const auth = useAuth();
  const {customer_id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    app.showHeader();
    document.title = 'KUVO Care';
  });

  if (!auth.state.devices?.length) {
    return '';
  }
  const device = auth.state.devices.find(d => d.customer_id == customer_id);
  let disabled = false;

  if (!device || !device.care || !device.care.is_target_country ||
      !device.care.status || !device.care.url || device.care.apply_type != 0) {
    disabled = true;
  }

  return (
      <Page>
        <PageMainTitle><span>KUVO Care</span></PageMainTitle>
        <PageFeatureTitle>
          <h2>Request this device for
            the KUVO Care.</h2>
        </PageFeatureTitle>

        <RegisteredDeviceBlock>
          <RegisteredDeviceDataArea>
            <RegisteredDeviceImageArea
                style={{
                  backgroundImage: `url(${device.image_url})`,
                }}
            />
            <RegisteredDeviceInfoArea>
              <RegisteredDeviceInfo>
                <h4>Device model</h4>
                <span>{device.device_name}</span>
              </RegisteredDeviceInfo>
              <RegisteredDeviceInfo>
                <h4>KUVO Device ID</h4>
                <span>{device.customer_id}</span>
              </RegisteredDeviceInfo>
              <RegisteredDeviceInfo>
                <h4>Serial no.</h4>
                <span>{device.serial_code || '- - - - - - - - - -'}</span>
              </RegisteredDeviceInfo>
            </RegisteredDeviceInfoArea>
          </RegisteredDeviceDataArea>


        </RegisteredDeviceBlock>

        <LabelAboveButton>*KUVO Care is currently eligible only with
          CDJ-3000.</LabelAboveButton>

        {
          disabled ? (
              <button className="dark-button center-fixed" disabled={true}>
                <span>Apply</span>
              </button>
          ) : (
              <ApplyButton href={device.care.url}
                           target="_blank"
                           rel="noopener"
                           className="dark-button center-fixed"
              >
                <span>Apply</span>
                <i></i>
              </ApplyButton>
          )
        }

        <LabelBelowButton>You will be redirected to the service site of your
          territory.</LabelBelowButton>

        <button href={'#'} onClick={(e) => {
          e.preventDefault();
          navigate('/devices/');
        }}
                style={{
                  display: 'block',
                  margin: '40px auto 0',
                }}
                className="light-button"
        ><span>Back to the device menu</span></button>
      </Page>
  );
}
